/**
 * Batch 27h — Filter row above the SA Tenants table.
 *
 * Search input is debounced upstream by the parent (300ms) so this stays a
 * pure presentational component.
 */
import type {
  TenantSortKey,
  TenantStatusFilter,
} from "@/hooks/queries/admin/useAdminTenants";

interface Props {
  status: TenantStatusFilter;
  sort: TenantSortKey;
  q: string;
  onStatus: (next: TenantStatusFilter) => void;
  onSort: (next: TenantSortKey) => void;
  onQuery: (next: string) => void;
}

export function TenantsFilters({
  status,
  sort,
  q,
  onStatus,
  onSort,
  onQuery,
}: Props): JSX.Element {
  const inputClass =
    "rounded-md border border-[var(--p-slate-150)] bg-white px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 dark:border-white/10 dark:bg-surface-canvas dark:text-text-primary dark:focus:ring-brand-teal";
  const labelClass =
    "block text-xs font-medium text-text-secondary dark:text-brand-100/70";
  return (
    <div className="flex flex-wrap items-end gap-3">
      <div>
        <label className={labelClass} htmlFor="tenant-search">
          Search
        </label>
        <input
          id="tenant-search"
          type="search"
          value={q}
          onChange={(e) => onQuery(e.target.value)}
          placeholder="Name or slug"
          className={`${inputClass} w-64`}
        />
      </div>
      <div>
        <label className={labelClass} htmlFor="tenant-status">
          Status
        </label>
        <select
          id="tenant-status"
          value={status}
          onChange={(e) => onStatus(e.target.value as TenantStatusFilter)}
          className={inputClass}
        >
          <option value="all">All</option>
          <option value="active">Active</option>
          <option value="suspended">Suspended</option>
          <option value="pending_deletion">Pending deletion</option>
        </select>
      </div>
      <div>
        <label className={labelClass} htmlFor="tenant-sort">
          Sort
        </label>
        <select
          id="tenant-sort"
          value={sort}
          onChange={(e) => onSort(e.target.value as TenantSortKey)}
          className={inputClass}
        >
          <option value="created_at_desc">Newest first</option>
          <option value="created_at_asc">Oldest first</option>
          <option value="name_asc">Name A–Z</option>
          <option value="name_desc">Name Z–A</option>
        </select>
      </div>
    </div>
  );
}
